export default __webpack_public_path__ + "static/media/Aura-Egg__36.7c086985.png";